import { useState, useEffect } from 'react';
import { Grid, IconButton, Box, Badge, Typography, Autocomplete, TextField } from '@mui/material';
import { myApi } from '../../../config/axiosConfig';
import Swal from 'sweetalert2';

// ICONOS
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import BeenhereIcon from '@mui/icons-material/Beenhere';

// COMPONENTES
import MiTabla from '../../../components/plantilla/tabla/MiTabla';
import ModalDetalles from './modales/ModalDetalles';

const Activos = ({ eventos, indicencias, refresh }) => {

    // =========================================
    // ESTADOS PARA MODAL
    // =========================================

    const [showModal, setShowModal] = useState(false);

    const [selected, setSelected] = useState({
        reason_id: null,
        solution: null
    });

    const handleModal = () => {

        setShowModal(!showModal);

    }

    const catalogoColores = {

        'HIGH': 'red',
        'MEDIUM': 'orange',
        'LOW': 'blue',

    }

    // =========================================
    // FUNCION PARA CERRAR CASO
    // =========================================

    const cerrarCaso = ( event ) => {

        Swal.fire({
            icon: 'question',
            title: 'Desea Cerrar el evento ?',
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: "Cancelar",
            confirmButtonText: "Cerrar"
        }).then( async (result) => {

            if(result.isConfirmed){

                try {

                    const payload = {

                        location: event.location,
                        vehicle: event.vehicle,

                    }

                    const response = await myApi.put('/idle/events/close', payload);
        
                    if(response.data){
        
                        Swal.fire({
                            icon: 'success',
                            title: 'Evento cerrado',
                        });

                        refresh();
        
                    }
        
                } catch(e) {
        
                    console.log(e);
        
                }

            }

        })

    }

    // =========================================
    // COLUMNAS
    // =========================================

    const columns = [

        { 
            field: 'vehicle', 
            headerName: 'Unidad',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) =>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 2 }}>
                    
                    <Badge 
                        badgeContent={params.row.total_registros} 
                        color="error"
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        sx={{ marginRight: 2 }}
                    />

                    <Typography>{params.row.company} - {params.row.vehicle}</Typography>

                </Box>
        },
        { 
            field: 'vehicle_fleet', 
            headerName: 'Fleet',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => 
                <Box>
                {params.row.vehicle_fleet} | {params.row.vehicle_type_of}
                </Box>
        },
        { 
            field: 'driver', 
            headerName: 'Conductor',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'location', 
            headerName: 'Locacion',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'event_date', 
            headerName: 'Fecha',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        { 
            field: 'reason', 
            headerName: 'Motivo',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => params.row.reason || 'PENDIENTE'
        },
        { 
            field: 'severity', 
            headerName: 'Prioridad',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => 
                <Box
                    sx={{
                        color: 'white',
                        backgroundColor: params.row.severity !== null ? catalogoColores[params.row.severity] : 'grey',
                    }}
                >
                    {params.row.severity !== null ? params.row.severity : 'PENDIENTE'}
                </Box>
        },
        { 
            field: '', 
            headerName: '',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) =>
                <Box>
                    <a href={params.row.incident_url} target="_blank" rel="noopener noreferrer">
                        <IconButton
                            color='primary'
                        >
                            <GpsFixedIcon />
                        </IconButton>
                    </a>
                    <IconButton
                        onClick={() => {
                            handleModal();
                            setSelected(params.row);
                        }}
                        color='warning'
                    >
                        <BorderColorIcon />
                    </IconButton>
                    {params.row.reason_id !== null && params.row.solution !== null && (
                        <IconButton
                            onClick={() => cerrarCaso(params.row)}
                            color='success'
                        >
                            <BeenhereIcon />
                        </IconButton>
                    )}
                </Box>
        },

    ];

    const [filtro, setFiltro] = useState('Company');
    const [valorFiltro, setValorFiltro] = useState(null);
    const [idleEvents, setIdleEvents] = useState([]);

    const handleFilter = ( event, newValue ) => {

        setFiltro(newValue);
        setValorFiltro(null);

    }

    const [filterOptions, setFilterOptions] = useState({
        Company: [],
        Fleet: [],
        Type: []
    });

    const handleFilterEvents = (event, newValue) => {

        setValorFiltro(newValue);

        if(filtro === 'Company'){
            setIdleEvents(eventos.filter(evento => evento.company === newValue));
        } else if(filtro === 'Fleet'){
            setIdleEvents(eventos.filter(evento => evento.vehicle_fleet === newValue));
        } else if(filtro === 'Type'){
            setIdleEvents(eventos.filter(evento => evento.vehicle_type_of === newValue));
        }

    }

    useEffect(() => {

        setFilterOptions({
            Company: [...new Set(eventos.map(evento => evento.company))],
            Fleet: [...new Set(eventos.map(evento => evento.vehicle_fleet))],
            Type: [...new Set(eventos.map(evento => evento.vehicle_type_of))]
        });

        setIdleEvents([...eventos])

    },[eventos]);

    // =========================================

    return (

        <Grid container>

            <Grid size={4}>

                <Autocomplete
                    disablePortal
                    options={['Company', 'Fleet', 'Type']}
                    sx={{ width: 300, marginBottom: 2 }}
                    onChange={handleFilter}
                    renderInput={(params) => <TextField {...params} label="Filtro" />}
                />

            </Grid>

            <Grid size={4}>

                <Autocomplete
                    disablePortal
                    options={filterOptions[filtro]}
                    sx={{ width: 300, marginBottom: 2 }}
                    value={valorFiltro}
                    onChange={handleFilterEvents}
                    renderInput={(params) => <TextField {...params} label={filtro} />}
                />

            </Grid>

            <Grid size={12}>

                <MiTabla
                    columns={columns}
                    data={idleEvents}
                />

            </Grid>

            <ModalDetalles
                open={showModal}
                onClose={handleModal}
                refresh={refresh}
                data={selected}
                incidencias={indicencias}
            />

        </Grid>

    )

}

export default Activos